export default [
  {
    path: '/app/user-types',
    name: 'UserTypes',
    component: () => import('@/views/User_types/Index.vue'),
    meta: {
      pageTitle: 'Kullanıcı Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_USER_TYPE_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/user-types/add',
    name: 'UserTypeAdd',
    component: () => import('@/views/User_types/Add.vue'),
    meta: {
      pageTitle: 'Kullanıcı Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/user-types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_USER_TYPE_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/user-types/edit/:id',
    name: 'UserTypeEdit',
    component: () => import('@/views/User_types/Edit.vue'),
    meta: {
      pageTitle: 'Kullanıcı Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/user-types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_USER_TYPE_EDIT',
      action: 'read',
    },
  },
]
